import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { AppService, GRSSUserRoles } from '../_services/app.service';

@Injectable({
  providedIn: 'root'
})
export class ContributorGuard  {

  constructor(private service: AppService) { }

  // Changed the default code to this for wait(avoid executing the next line) until gets the result.
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    if (this.service.currentUser === undefined) {
      return new Promise((resolve, reject) => {
        this.service.CheckAuth().then(e => {
          if (this.service.currentUser.userRole === GRSSUserRoles.Staff || this.service.currentUser.userRole === GRSSUserRoles.Assessor) {
            resolve(false);
          } else {
            resolve(true);
          }
        });
      });
    } else if (this.service.currentUser.userRole === GRSSUserRoles.Staff || this.service.currentUser.userRole === GRSSUserRoles.Assessor) {
      return false;
    } else {
      return true;
    }
  }

}
